import { NgModule } from '@angular/core';
import { ControlErrorComponent } from './control-error.component';
import { ControlErrorContainerDirective, ControlErrorsDirective } from './control-errors';
import { DisableUserActionDirective } from './disable-user-action-directive';
import { FormSubmitDirective } from './form-submit';
import { GlobalInputValidationDirective } from './global-input-validation.directive';
@NgModule({
  declarations: [ControlErrorContainerDirective, ControlErrorsDirective, FormSubmitDirective, ControlErrorComponent,
    GlobalInputValidationDirective,DisableUserActionDirective],
  exports: [ControlErrorContainerDirective, ControlErrorsDirective, FormSubmitDirective,
    GlobalInputValidationDirective,DisableUserActionDirective],
  entryComponents: [ControlErrorComponent]
})
export class FormControlErrorDirectivesModule { }
